import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import Loading from "../../../../common/components/Loading";
import ElectrodependentContextProvider, { ACTIONS, ElectrodependentContext } from '../../context/ElectrodependentContextProvider';
import { validateEmailFunc, isRutValid, validateCell, beforeMaskedValueChangeRut, decode_utf8, maxFileSize, getSignedIdStatus, extensionsAccepted, transformId } from '../../../../common/utils/utilsFunc';
import WebContentTermsElectrod from '../WebContentTermsElectrod';
import { useModal } from "@clayui/modal";
import FileUploaded from "../../../../common/components/FileUploader";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function CambioDomicilio({ props }) {
    const [state, dispatch] = React.useContext(ElectrodependentContext)
    const [cellphonePaciente, setCellphonePaciente] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [correoPaciente, setCorreoPaciente] = React.useState('');
    const [nombreTutor, setNombreTutor] = React.useState('');
    const [ruTutor, setRutTutor] = React.useState('');
    const [telefonoTutor, setTelefonoTutor] = React.useState('');
    const [correoTutor, setCorreoTutor] = React.useState('');
    const [telefonoContacto, setTelefonoContacto] = React.useState('');
    const [correoContacto, setCorreoContacto] = React.useState('');
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [valueCheckBoxTerms, setValueCheckBoxTerms] = React.useState(false);
    const [erroUploadFile, setErroUploadFile] = React.useState();
    const [newDetailClientJson, setNewDetailClientJson] = React.useState([]);
    const [values, setValues] = React.useState({})
    const [errorCli, setErrorCli] = React.useState(false);
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
   
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModal2, setVisibleModal2] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => { 
            setVisibleModal(false);
            setVisibleModal2(false)
         }
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "setVisibleModal": setVisibleModal2,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModal2,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentTextInfo
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    React.useEffect(() => {
        if (props.resetForm) {
            setValues({
                regionPatient: "",
                comunaPatient: "",
                calleNDptoPatient: "",
                cellphonePatient: "",
                telContacto: "",
                emailContacto: "",
                cellphoneTutor: "",
                diagnosticPatient: "",
                descuento: "",
                edadPatient: "",
                emailPatient: "",
                emailTutor: "",
                fechaDesde: "",
                fechaHora: "",
                fileCertificate: null,
                fileContactData: null,
                fileCredentialRepres: null,
                filePatientIdentity: null,
                filePatientRepresIdentity: null,
                ticketCopy: null,
                namePatient: "",
                nameTutor: "",
                rutPatient: "",
                rutTutor: ""
            })
            clearInputFile("fileCertificate")
            clearInputFile("fileContactData")
            clearInputFile("fileCredentialRepres")
            clearInputFile("filePatientIdentity")
            clearInputFile("filePatientRepresIdentity")
            clearInputFile("ticketCopy")
            setValueCheckBoxTerms(false)
            setNewDetailClientJson([])
            props.setResetForm(false)
        }
    }, [props.resetForm])

    React.useEffect(() => {
        if (erroUploadFile) {
            props.setGlobalAlert(erroUploadFile, "warning");
        }
    }, [erroUploadFile]);

    function clearInputFile(id) {
        let inputFile = document.querySelector(`#${id}`);
        inputFile.value = ''
    }
    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };



        if (valueCheckBoxTerms) {
            errors.empty.valueCheckBoxTerms = false;
        } else {
            errors.empty.valueCheckBoxTerms = true;
            errors.msg.valueCheckBoxTerms = "Debes aceptar los términos y condiciones."
        }

        if (values.fileCertificate) {
            errors.empty.fileCertificate = false;
        } else {
            errors.empty.fileCertificate = true;
            errors.msg.fileCertificate = "Debes adjuntar certificado médico que acredita condición de electrodependencia"
        }

        if (values.fileContactData) {
            errors.empty.fileContactData = false;
        } else {
            errors.empty.fileContactData = true;
            errors.msg.fileContactData = "Debes adjuntar el formulario con los datos de contacto con el paciente y su representante o apoderado"
        }

        if (values.filePatientIdentity) {
            errors.empty.filePatientIdentity = false;
        } else {
            errors.empty.filePatientIdentity = true;
            errors.msg.filePatientIdentity = "Debes adjuntar Cédula de Identidad del paciente electrodependiente"
        }

        if (values.filePatientRepresIdentity) {
            errors.empty.filePatientRepresIdentity = false;
        } else {
            errors.empty.filePatientRepresIdentity = true;
            errors.msg.filePatientRepresIdentity = "Debes adjuntar Cédula de Identidad del representante o apoderado del paciente electrodependiente"
        }

        if (values.ticketCopy) {
            errors.empty.ticketCopy = false;
        } else {
            errors.empty.ticketCopy = true;
            errors.msg.ticketCopy = "Debes adjuntar copia de la boleta donde se inscribe al paciente electrodependiente"
        }

        if (values.fileCredentialRepres) {
            errors.empty.fileCredentialRepres = false;
        } else {
            errors.empty.fileCredentialRepres = true;
            errors.msg.fileCredentialRepres = "Debes adjuntar documento que acredita al representante o apoderado del paciente"
        }

        if (correoTutor) {
            errors.empty.emailTutor = false;
            if (correoTutor && !validateEmailFunc(correoTutor)) {
                errors.validated.emailTutor = true;
                errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del paciente válido"
            } else {
                errors.validated.emailTutor = false;
            }
        } else {
            errors.empty.emailTutor = true;
            errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del paciente"
        }

        if (ruTutor) {
            errors.empty.rutTutor = false;
            if (!isRutValid(ruTutor)) {
                errors.validated.rutTutor = true;
                errors.msg.rutTutor = "Debes ingresar un RUT del representante legal o apoderado del paciente válido."
            } else {
                errors.validated.rutTutor = false;
            }
        } else {
            errors.empty.rutTutor = true;
            errors.msg.rutTutor = "Debes ingresar el RUT del representante legal o apoderado del paciente."
        }


        if (nombreTutor) {
            errors.empty.nameTutor = false;
        } else {
            errors.empty.nameTutor = true;
            errors.msg.nameTutor = "Debe ingresar nombre del representante legal o apoderado del paciente."
        }

        if (values.newIdClient) {
            errors.empty.newIdClient = false;
        } else {
            setErrorCli(true);
            errors.msg.newIdClient = "Debe ingresar nuevo número de cliente"
        }

        if (telefonoContacto) {
            errors.empty.telContacto = false;
            if (validateCell(telefonoContacto)) {
                errors.validated.telContacto = true;
                errors.msg.telContacto = "Debes ingresar un teléfono válido"
            } else {
                errors.validated.telContacto = false;
            }
        } else {
            errors.empty.telContacto = true;
            errors.msg.telContacto = "Debes ingresar el teléfono del contacto"
        }

        if (cellphonePaciente) {
            errors.empty.cellphonePatient = false;
            if (validateCell(cellphonePaciente)) {
                errors.validated.cellphonePatient = true;
                errors.msg.cellphonePatient = "Debes ingresar un teléfono válido"
            } else {
                errors.validated.cellphonePatient = false;
            }
        } else {
            errors.empty.cellphonePatient = true;
            errors.msg.cellphonePatient = "Debes ingresar el teléfono del contacto"
        }

        if (correoPaciente) {
            errors.empty.emailPatient = false;
            if (correoPaciente && !validateEmailFunc(correoPaciente)) {
                errors.validated.emailPatient = true;
                errors.msg.emailPatient = "Debes ingresar el correo electrónico del contacto válido"
            } else {
                errors.validated.emailPatient = false;
            }
        } else {
            errors.empty.emailPatient = true;
            errors.msg.emailPatient = "Debes ingresar el correo electrónico del paciente"
        }

        if (correoContacto) {
            errors.empty.emailContacto = false;
            if (correoContacto && !validateEmailFunc(correoContacto)) {
                errors.validated.emailContacto = true;
                errors.msg.emailContacto = "Debes ingresar el correo electrónico del contacto válido"
            } else {
                errors.validated.emailContacto = false;
            }
        } else {
            errors.empty.emailContacto = true;
            errors.msg.emailContacto = "Debes ingresar el correo electrónico del contacto"
        }
        if (telefonoTutor) {
            errors.empty.cellphoneTutor = false;
            if (validateCell(telefonoTutor)) {
                errors.validated.cellphoneTutor = true;
                errors.msg.cellphoneTutor = "Debes ingresar un correo electrónico del representante legal o apoderado del paciente que sea válido"
            } else {
                errors.validated.cellphoneTutor = false;
            }
        } else {
            errors.empty.cellphoneTutor = true;
            errors.msg.cellphoneTutor = "Debes ingresar el teléfono del representante legal o apoderado del paciente"
        }

        setInputValidate(errors)
        return errors
    }



    function handleSubmit() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        } else if (!newDetailClientJson || newDetailClientJson.length === 0) {
            props.setGlobalAlert("Debe buscar un nuevo número de cliente.", "warning");
        } else {
            let json = [
                {
                    "idSolicitudED": props.detailSolcitudJson.id,
                    "nroCliente": props.detailClientJson.CTA_CTO,
                    "newNroCliente": values.newIdClient,
                    "nombrePaciente": props.detailSolcitudJson.nombrePaciente,
                    "rutPaciente": props.detailSolcitudJson.rutPaciente,
                    "fonoPaciente": cellphonePaciente,
                    "emailPaciente": correoPaciente,
                    "edadPaciente": props.detailSolcitudJson.edadPaciente,
                    "diagnosticoPaciente": props.detailSolcitudJson.diagnosticoPaciente,
                    "descuentoPaciente": props.detailSolcitudJson.descuentoPaciente,
                    "calleNDptoPatient": props.detailSolcitudJson.direccionPaciente,
                    "regionPatient": props.detailSolcitudJson.regionPaciente,
                    "comunaPatient": props.detailSolcitudJson.comunaPaciente,
                    "nombreTutor": nombreTutor,
                    "rutTutor": ruTutor,
                    "fonoTutor": telefonoTutor,
                    "emailTutor": correoTutor,
                    "fonoInterrupcion": telefonoContacto,
                    "emailInterrupcion": correoContacto,
                    "fechaDesde": props.detailSolcitudJson?.fechaDesde ? props.detailSolcitudJson.fechaDesde.split("T")[0] : "",
                    "fechaHasta": props.detailSolcitudJson?.fechaHasta ? props.detailSolcitudJson.fechaHasta.split("T")[0] : "",
                    "newComunaPatient":  newDetailClientJson?.COMUNA ? newDetailClientJson?.COMUNA : "",
                    "newRegionPatient":  newDetailClientJson?.REGION ? newDetailClientJson?.REGION : "",
                    "newCalleNDptoPatient":  newDetailClientJson?.CALLE ? newDetailClientJson?.CALLE : "",
                    "signedIn": getSignedIdStatus(),
                    // eslint-disable-next-line no-undef
                    "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
                    "contentName": decode_utf8(props.web_content_return_fetch_electrodependent),
                    "empresa": props.codigo_empresa,
                    "url": props.url_ws_empresa
                },
                {
                    "certificado": values.fileCertificate,
                    "formulario": values.fileContactData,
                    "identidadPaciente": values.filePatientIdentity,
                    "identidRepresentante": values.filePatientRepresIdentity,
                    "boleta": values.ticketCopy,
                    "procuracion": values.fileCredentialRepres
                }
            ]
            console.log("JSON ENVIADO RE" + json.toString)
            props.setJsonFormCd(json)
        }

    }

    React.useEffect(() => {
        if (props.detailSolcitudJson) {
            console.log("DETAILS:" + props.detailSolcitudJson);
            setCellphonePaciente(props.detailSolcitudJson?.fonoPaciente || "")
            setCorreoPaciente(props.detailSolcitudJson?.emailPaciente || "")
            setNombreTutor(props.detailSolcitudJson?.nombreTutor || "")
            setRutTutor(props.detailSolcitudJson?.rutTutor || "")
            setTelefonoTutor(props.detailSolcitudJson?.fonoTutor || "")
            setCorreoTutor(props.detailSolcitudJson?.emailTutor || "")
            setTelefonoContacto(props.detailSolcitudJson?.fonoInterrupcion || "")
            setCorreoContacto(props.detailSolcitudJson?.emailInterrupcion || "")
        }
    }, [props.detailSolcitudJson]);

 React.useEffect(() => {
        if (state.newDetailClient) {
          if (state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if (state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                setNewDetailClientJson(state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.ITEM);
                setLoading(false);
            } else {
                setNewDetailClientJson([]);
                props.setGlobalAlert(state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.newDetailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) , "warning", true, "Advertencia");
                setLoading(false);
            }
          } else {
            setLoading(false);
            setNewDetailClientJson([]);
            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          }
        }
    }, [state.newDetailClient])

    function handleButton() {
        if (!values.newIdClient) {
            setErrorCli(true)
            props.setGlobalAlert("Ingrese nuevo número de cliente", "warning");
            dispatch({
                payload: null,
                type: ACTIONS.SET_NEWIDCLIENT,
            })
            setNewDetailClientJson([]);
        } else {
            setNewDetailClientJson([]);
            setLoading(true);
            setErrorCli(false)
            dispatch({
                payload: values.newIdClient,
                type: ACTIONS.SET_NEWIDCLIENT,
            })
        }
    }

    return (
        <div id="cge-formselectrodependent">
            <CGE.Panel>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.Heading
                            className="color-blue font-weight-bold"
                            size="4"
                            text={"Domicilio registrado en solicitud n°: " + props.detailSolcitudJson?.nroSolicitud}

                        />
                    </div>
                </div>
                <CGE.PanelSection
                    title={"Se certifica como electrodependiente al paciente individualizado como:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, namePatient: props.detailSolcitudJson?.nombrePaciente })}
                                idFormElement="namePatient"
                                typeElement="input"
                                labelName="Nombre:"
                                placeholder="Nombre Completo"
                                maxLength="100"
                                hasError={inputValidate?.empty?.namePatient}
                                msgError={inputValidate?.msg?.namePatient}
                                value={props.detailSolcitudJson?.nombrePaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, rutPatient: props.detailSolcitudJson?.rutPaciente })}
                                idFormElement="rutPatient"
                                labelName="Rut:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutPatient || inputValidate?.validated?.rutPatient}
                                msgError={inputValidate?.msg?.rutPatient}
                                value={props.detailSolcitudJson?.rutPaciente || ""}
                                readOnly={true}
                                typeElement="input-mask"
                                maxLength="12"
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setCellphonePaciente(e.target.value)}
                                idFormElement="cellphonePatient"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphonePatient || inputValidate?.validated?.cellphonePatient}
                                msgError={inputValidate?.msg?.cellphonePatient}
                                value={cellphonePaciente}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setCorreoPaciente(e.target.value)}
                                idFormElement="emailPatient"
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailPatient || inputValidate?.validated?.emailPatient}
                                msgError={inputValidate?.msg?.emailPatient}
                                value={correoPaciente}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, edadPatient: props.detailSolcitudJson.edadPaciente })}
                                idFormElement="edadPatient"
                                labelName="Edad:"
                                placeholder="Edad"
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                value={props.detailSolcitudJson.edadPaciente || ""}
                                readOnly={true}
                                typeFormElement="text"
                                typeElement="input-mask"
                                maxLength="2"
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="99"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, diagnosticPatient: props.detailSolcitudJson.diagnosticoPaciente })}
                                idFormElement="diagnosticPatient"
                                typeElement="input"
                                maxLength="100"
                                labelName="Diagnóstico médico/Patología de Base:"
                                placeholder="Diagnóstico médico"
                                value={props.detailSolcitudJson.diagnosticoPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, descuento: props.detailSolcitudJson.descuentoPaciente || "" })}
                                idFormElement="descuento"
                                typeElement="input"
                                maxLength="100"
                                labelName="Descuento informado en solicitud de alta:"
                                placeholder="Descuento informado en solicitud de alta"
                                value={props.detailSolcitudJson.descuentoPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Domicillio en donde reside el paciente:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, calleNDptoPatient: props.detailSolcitudJson?.direccionPaciente })}
                                idFormElement="calleNDptoPatient"
                                typeElement="input"
                                labelName="Calle, N°, Dpto:"
                                placeholder="Calle, N°, Dpto"
                                hasError={inputValidate?.empty?.calleNDptoPatient}
                                msgError={inputValidate?.msg?.calleNDptoPatient}
                                value={props.detailSolcitudJson?.direccionPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, regionPatient: props.detailSolcitudJson?.regionPaciente })}
                                idFormElement="regionPatient"
                                labelName="Región:"
                                typeElement="input"
                                hasError={inputValidate?.empty?.regionPatient}
                                msgError={inputValidate?.msg?.regionPatient}
                                value={props.detailSolcitudJson?.regionPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, comunaPatient: props.detailSolcitudJson?.comunaPaciente })}
                                idFormElement="comunaPatient"
                                labelName="Comuna:"
                                typeElement="input"
                                value={props.detailSolcitudJson?.comunaPaciente || ""}
                                readOnly={true}
                                hasError={inputValidate?.empty?.comunaPatient}
                                msgError={inputValidate?.msg?.comunaPatient}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Datos del representante legal o apoderado del paciente:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setNombreTutor(e.target.value)}
                                idFormElement="nameTutor"
                                typeElement="input"
                                labelName="Nombre:"
                                maxLength="100"
                                placeholder="Nombre Completo"
                                hasError={inputValidate?.empty?.nameTutor}
                                msgError={inputValidate?.msg?.nameTutor}
                                value={nombreTutor}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setRutTutor(e.target.value)}
                                idFormElement="rutTutor"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                labelName="RUT:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutTutor || inputValidate?.validated?.rutTutor}
                                msgError={inputValidate?.msg?.rutTutor}
                                value={ruTutor}
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                maxLength="12"
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setTelefonoTutor(e.target.value)}
                                idFormElement="cellphoneTutor"
                                mandatoryElement={true}
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphoneTutor || inputValidate?.validated?.cellphoneTutor}
                                msgError={inputValidate?.msg?.cellphoneTutor}
                                value={telefonoTutor}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setCorreoTutor(e.target.value)}
                                idFormElement="emailTutor"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailTutor || inputValidate?.validated?.emailTutor}
                                msgError={inputValidate?.msg?.emailTutor}
                                value={correoTutor}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Datos de contacto en caso de interrupción informados:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setTelefonoContacto(e.target.value)}
                                idFormElement="telContacto"
                                mandatoryElement={true}
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.telContacto || inputValidate?.validated?.telContacto}
                                msgError={inputValidate?.msg?.telContacto}
                                value={telefonoContacto}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setCorreoContacto(e.target.value)}
                                idFormElement="emailContacto"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailContacto || inputValidate?.validated?.emailContacto}
                                msgError={inputValidate?.msg?.emailContacto}
                                value={correoContacto}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Fechas informadas por Electrodependencia:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaDesde: props.detailSolcitudJson?.fechaDesde })}
                                idFormElement="fechaDesde"
                                typeElement="input"
                                labelName="Fecha Desde:"
                                placeholder="Fecha Desde"
                                hasError={inputValidate?.empty?.fechaDesde || inputValidate?.validated?.fechaDesde}
                                msgError={inputValidate?.msg?.fechaDesde}
                                value={props.detailSolcitudJson?.fechaDesde
                                    ? props.detailSolcitudJson.fechaDesde.split("T")[0] : ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaHora: props.detailSolcitudJson?.fechaHasta })}
                                idFormElement="fechaHora"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Fecha Hasta:"
                                placeholder="Fecha Hasta"
                                hasError={inputValidate?.empty?.fechaHora || inputValidate?.validated?.fechaHora}
                                msgError={inputValidate?.msg?.fechaHora}
                                value={props.detailSolcitudJson?.fechaHasta
                                    ? props.detailSolcitudJson.fechaHasta.split("T")[0] : ""}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Nuevo domicilio paciente Electro Dependiente:"}>
                   <CGE.DetailClient
                    props={{
                        handleChange: (e) => setValues({ ...values, newIdClient: e.target.value }),
                    hasError: errorCli,
                    msgError: "Debe ingresar nuevo número de cliente",
                    idClient: values.newIdClient,
                    idFormElement: "newIdClient",
                    labelName: "Nuevo número de Cliente:",
                    placeholder: "Nuevo número de Cliente",
                    mandatoryElement: true,
                    valuePub: values.newIdClient,
                    labelButton: "Buscar",
                    handleClick: () => { handleButton() },
                    sizeButton: "sm",
                    typeButton: "primary",
                    propsLabelInfoContent: propsLabelInfoContent
                    }}
                    propsDetail={{
                        fullNameClient: "",
                        comunaClient: newDetailClientJson?.COMUNA ? newDetailClientJson?.COMUNA : "",
                        calleClient: newDetailClientJson?.CALLE ? newDetailClientJson?.CALLE : "",
                        nCalleClient: newDetailClientJson?.NUMERO_CASA ? newDetailClientJson?.NUMERO_CASA : "",
                        dptoBlockClient: (newDetailClientJson?.SUPLEMENTO || newDetailClientJson?.PISO) ? `${newDetailClientJson?.SUPLEMENTO} 
                            ${newDetailClientJson?.PISO}` : "",
                        ctaCtoClient: newDetailClientJson?.CTA_CTO
                    }}
                />
                </CGE.PanelSection>
                <CGE.PanelSection>
                    <div className="row">
                        <div className="col-md-12">
                            <CGE.Heading
                                className="color-blue font-weight-bold mb-2"
                                size="4"
                                text={decode_utf8(props.description_forms_tipos_documentacion)}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileCertificate"
                                labelInput="Certificado médico que acredita condición de electrodependencia:"
                                deleteFile={() => setValues({ ...values, 'fileCertificate': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileCertificate': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileCertificate || inputValidate?.validated?.fileCertificate}
                                msgError={inputValidate?.msg?.fileCertificate}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="filePatientIdentity"
                                labelInput="Cédula de Identidad del paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'filePatientIdentity': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'filePatientIdentity': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.filePatientIdentity || inputValidate?.validated?.filePatientIdentity}
                                msgError={inputValidate?.msg?.filePatientIdentity}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileContactData"
                                labelInput="Formulario con los datos de contacto con el paciente y su representante (o apoderado):"
                                deleteFile={() => setValues({ ...values, 'fileContactData': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileContactData': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileContactData || inputValidate?.validated?.fileContactData}
                                msgError={inputValidate?.msg?.fileContactData}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="filePatientRepresIdentity"
                                labelInput="Cédula de Identidad del representante (o apoderado) (*) del paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'filePatientRepresIdentity': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'filePatientRepresIdentity': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.filePatientRepresIdentity || inputValidate?.validated?.filePatientRepresIdentity}
                                msgError={inputValidate?.msg?.filePatientRepresIdentity}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="ticketCopy"
                                labelInput="Copia de la boleta donde se inscribe al paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'ticketCopy': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'ticketCopy': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.ticketCopy || inputValidate?.validated?.ticketCopy}
                                msgError={inputValidate?.msg?.ticketCopy}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>

                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileCredentialRepres"
                                labelInput="Documento que acredita al representante (o apoderado) (*) del paciente:"
                                deleteFile={() => setValues({ ...values, 'fileCredentialRepres': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileCredentialRepres': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileCredentialRepres || inputValidate?.validated?.fileCredentialRepres}
                                msgError={inputValidate?.msg?.fileCredentialRepres}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.Text
                                className="color-blue font-weight-bold mb-2"
                                size="2"
                                text="(*): Si el paciente es su propio representante legal y no posee apoderado, ingresar la cédula de
                                 identidad de paciente en reemplazo de la cédula de identidad del representante (o apoderado) y como 
                                 documento que lo acredita como tal."
                            />
                            <CGE.Text
                                className="color-blue font-weight-bold mb-2"
                                size="2"
                                text="(*): En caso de contar con descuento a potencia nomial, es necesario incorporar los respaldos de las placas de los aparatos en la misma
                                sección de carga 'Copia de boleta donde se inscribe el paciente electrodependiente'."
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title="9. Términos y condiciones">
                    <div className="row">
                        <div className="col-md-12">
                            <WebContentTermsElectrod
                                props={props}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxTerms}
                                labelName="Acepto los términos y condiciones"
                                handleChange={() => setValueCheckBoxTerms((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={true}
                                typeElement="input"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FieldRecaptcha
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <CGE.Button
                            label="Enviar"
                            onClick={() => handleSubmit()}
                        />
                    </div>
                </CGE.PanelSection>
            </CGE.Panel>
            {loading && <Loading />}
        </div>
    )
}
export default CambioDomicilio